<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']" 
  :style="{
      background: tenantConfig.homeBgColor,
      'background-image': 'url(' + tenantConfig.homeBg + ')',
      'background-repeat': tenantConfig.homeBgRepeat,
    }">
    <Header id="header"/>
    <div class="home">
      <router-view />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import Header from "@/components/header/HeaderWayi";
import Header2 from "@/components/header/Header2";
import Header3 from "@/components/header/Header3";
import Banner from "../components/Banner";
import Footer from "@/components/footer/Footer";
export default {
  name: "HomeLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Header2,
    Header3,
    Banner,
    Footer,
  },
  data() {
    return {
      tenantConfig: {}
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
  },
};
</script>
<style>
a * {
  transition: all 0.1s ease;
}
</style>
<style lang="less" scoped>
.container {
  // padding-top: 75px;
  .banner-wrap {
    padding: 80px 0;
    background: #24a6e9;
    .banner-bg {
      position: absolute;
      width: 100%;
    }
    .banner {
      margin: auto;
      // max-width: 1200px;
      overflow: hidden;
      border-radius: 28px;
      box-shadow: 0px 6px 10px #0303031f;
    }
  }
  .home {
    // max-width: 1200px;
    // margin: 20px auto;
    // padding: 20px 10px;
    // background: #ffffffd1;
    min-height: 100vh;
    .pageLeft {
      width: 180px;
      height: calc(100vh - 75px);
      background: #fff;
    }
    // border-radius: 30px;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  // background: url(~@/assets/background.svg);
}
</style>